import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import ArrowRight from '@/presentation/assets/svg/ArrowRight.svg'
import CircleInfo from '@/presentation/assets/svg/CircleInfo'
import KnowMoreModal from '@/presentation/pages/RoomsPage/components/KnowMorePopup'
import { ROUTES } from '@/services/constants/routes'
import useNavigateWithOrderCode from '@/services/hooks/useNavigateWithOrderCode'
import { Status, useDivergence } from '@/services/providers/DivergenceContext'

const Footer: React.FC = () => {
  const [showKnowMoreModal, setShowKnowMoreModal] = useState(false)

  const { t } = useTranslation()

  const navigate = useNavigateWithOrderCode()

  const { divergences, status } = useDivergence()

  const handleGoToDivergences = () => {
    navigate(ROUTES.DIVERGENCE_LIST)
  }

  return (
    <div className="mb-8 flex w-full flex-col items-start justify-start">
      <span className="font-bold text-gray-500">
        {t('CONTESTATIONS', 'Contestações')}
      </span>

      {divergences.length > 0 ? (
        <div
          onClick={handleGoToDivergences}
          className="mt-2 flex w-full max-w-sm cursor-pointer items-center justify-center gap-x-2 rounded-xl border border-gray-300 bg-[#FAFAFA] p-4 text-primary shadow-sm"
        >
          <span className="flex-1 text-center">
            {t('SEE_CONTESTATIONS_AGAIN', 'Visualizar contestações')}
          </span>

          <img src={ArrowRight} alt="Arrow right icon" />
        </div>
      ) : status === Status.EXPIRED ? (
        <div className="mt-2">
          <div className="flex items-center gap-2">
            <CircleInfo color="#CF0000" className="shrink-0" />

            <span className="text-error">
              {t('CONTESTATION_EXPIRED', 'Prazo para contestação expirado')}
            </span>
          </div>
          <div>
            <span className="text-sm text-gray-500">
              {t(
                'CONTACT_ADMINISTRATOR',
                'Entre em contato com a administradora para habilitar as contestações da vistoria novamente.'
              )}
            </span>
          </div>
        </div>
      ) : (
        <>
          <span className="mt-2 text-gray-500">
            {t(
              'NO_CONTESTATIONS_AT_THE_MOMENT',
              'Sem contestações no momento.'
            )}
          </span>

          <div className="flex items-center gap-2">
            <CircleInfo
              className="cursor-pointer"
              onClick={() => setShowKnowMoreModal(true)}
            />

            <span
              className="cursor-pointer text-primary"
              onClick={() => setShowKnowMoreModal(true)}
            >
              {t('LEARN_MORE', 'Saiba mais')}
            </span>
          </div>
        </>
      )}

      {showKnowMoreModal && (
        <KnowMoreModal onCancel={() => setShowKnowMoreModal(false)} />
      )}
    </div>
  )
}

export default Footer
